// extracted by mini-css-extract-plugin
module.exports = {"prices":"PriceSummary_prices__PvXJT","price":"PriceSummary_price__3tqsw","headline":"PriceSummary_headline__2f_tD"};